<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-breakpoint="960"
    :right="$vuetify.rtl"
    mini-variant-width="60"
    :mini-variant.sync="variatMini"
    :permanent="expandOnHover"
    @transitionend="collapseSubItems"
    width="215"
    :expand-on-hover="expandOnHover"
    app
    id="main-sidebar"
    v-bar
  >
    <v-list-item style="background-color:#604E05" v-if="!$vuetify.breakpoint.xsOnly" two-line >
       <span    class="logo-icon  ">
        <img src="@/assets/images/logo_branca.svg" width="25" height="29  " />
      </span>
      <span    class="logo-text" :class="`${(expandOnHover && variatMini) ? 'hidelogo':'' }`">
        <img class="mr-4 ml-0 mt-0"   src="@/assets/images/docbit.svg"  width="130" height="39" />
      </span>
    </v-list-item>
    <v-list-item color="primary" v-else dense two-line >
       <span  class="logo-icon  ">
          <v-img class="ml-1 mt-0" src="@/assets/images/logo140x50.png"/>
      </span>
    </v-list-item>

    <v-divider >  </v-divider>

    <v-list    nav >
      <template v-for="(item, i) in items">
        <!---If Sidebar Caption -->
        <!-- <v-row v-if="item.header" :key="item.header" align="center">
          <v-col cols="12">
            <v-subheader v-if="item.header" class="d-block text-truncate">{{ item.header }}</v-subheader>
          </v-col>
        </v-row> -->
        <!---If Sidebar Caption -->
        <BaseItem  v-if="!item.children && checkPermission(item.permission)" :key="`item-${i}`" :item="item" />
        <BaseItemGroup   v-else :key="`group-${i}`" :item="item"></BaseItemGroup>
        
      </template>
      <!---Sidebar Items -->
    </v-list>

    <v-footer color="primary" absolute class="font-weight-medium">
    <v-col
      class="text-center text-caption pa-0"
      cols="12"
    >
      <span>1.00</span>
    </v-col>
  </v-footer>
  </v-navigation-drawer>
</template>

<script>
  import {mapMutations, mapState} from "vuex"
  import SidebarItems from "./SidebarItems"
  import checkPermissionsMixin from '@/mixins/check-permissions'

  export default {
  name: "Sidebar",
  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },
  mixins: [checkPermissionsMixin],
  data: () => ({
    items: SidebarItems,
   variatMini:false,
   showLogo: true,
  }),
   methods:{

    collapseSubItems() {
      this.items.map((item)=>{
       item.active=false
      })
    },
    showhideLogo: function() {
     this.showLogo = !this.showLogo;
    },
    ...mapMutations({
     setSidebarDrawer: "SET_SIDEBAR_DRAWER"
    }),
   },
  computed: {
    ...mapState(["SidebarColor", "SidebarBg"]),
    Sidebar_drawer: {
      get() {
        return this.$store.state.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit("SET_SIDEBAR_DRAWER", val);
      }
    }
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    }
  },
  mounted() {

  }
};
</script>
<style lang="scss">
#main-sidebar{
  box-shadow:1px 0 20px rgba(0,0,0,.08);
  -webkit-box-shadow:1px 0 20px rgba(0,0,0,.08);
  .v-navigation-drawer__border{
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item{
      &__icon--text,
      &__icon:first-child{
        justify-content: center;
        text-align: center;
        width: 20px;

      }
  }
  .hidelogo{
    display: none;
  }
  .profile-bg{
    background:url('../../../assets/images/user-info.jpg') no-repeat;
    .v-avatar{
      padding:45px 0;
    }
  }
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(0, 0, 0, 0.87) !important;
}
.tile {
  margin: 5px;
  border-radius: 4px;
}
.tile:hover {
  background: green;
}
.tile:active {
  background: yellow;
}
.tile {
  margin: 5px;
  border-radius: 4px;
}
.tile:hover {
  background: green;
}
.tile:active {
  background: yellow;
}
</style>